<template>
    <v-card>
        <v-card-title> Import Setup Data </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <v-file-input
                        label="Setup Data Excel File"
                        accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        style="max-width: 320px"
                        @update:model-value="updateSetupDataFile"
                    />
                </v-col>
            </v-row>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="cancel">Cancel</v-btn>
            <v-btn color="primary" @click="save">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { defineComponent } from "vue";

import { mapGetters } from "vuex";
import { withLoadingScreen } from "@/lib/loading";
import { measurementsAPI } from "@/services/api.services";

export default defineComponent({
    props: {
        experiment: {
            type: Object,
            required: true,
        },
        thingSchema: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            excelFile: null,
        };
    },

    computed: {
        ...mapGetters({
            user: "getAuthUser",
        }),
    },

    mounted() {},

    methods: {
        updateSetupDataFile(file) {
            this.excelFile = file;
        },
        cancel() {
            this.$emit("canceled");
        },
        save() {
            withLoadingScreen(async () => {
                const result = await measurementsAPI.importSetupData({
                    experimentCode: this.experiment.code,
                    thingSchemaId: this.thingSchema.id,
                    file: this.excelFile,
                });

                this.$emit("saved", result);
            });
        },
    },
});
</script>
